import * as Period from 'constants/Period';

const WATERPOLO_PERIOD_MAP = {};
WATERPOLO_PERIOD_MAP[800] = Period.NOT_STARTED;
WATERPOLO_PERIOD_MAP[801] = Period.FIRST;
WATERPOLO_PERIOD_MAP[802] = Period.FIRST_BREAK;
WATERPOLO_PERIOD_MAP[803] = Period.SECOND;
WATERPOLO_PERIOD_MAP[804] = Period.SECOND_BREAK;
WATERPOLO_PERIOD_MAP[805] = Period.THIRD;
WATERPOLO_PERIOD_MAP[806] = Period.THIRD_BREAK;
WATERPOLO_PERIOD_MAP[807] = Period.FOURTH;
WATERPOLO_PERIOD_MAP[808] = Period.FOURTH_BREAK;
WATERPOLO_PERIOD_MAP[809] = Period.OVERTIME;
WATERPOLO_PERIOD_MAP[810] = Period.FINISHED;

export default WATERPOLO_PERIOD_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Waterpolo/PeriodMap.js